import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.77 21.37A1 1 0 0029 21h-1V8a3 3 0 00-3-3H7a3 3 0 00-3 3v13H3a1 1 0 00-.77.37 1 1 0 00-.23.83l.38 1.8a5 5 0 004.9 4h17.44a5 5 0 004.9-4l.38-1.8a1 1 0 00-.23-.83zM6 8a1 1 0 011-1h18a1 1 0 011 1v13H6zm21.66 15.59A3 3 0 0124.72 26H7.28a3 3 0 01-2.94-2.41L4.22 23h8.16l.22.44A2.81 2.81 0 0015.13 25h1.74a2.81 2.81 0 002.53-1.56l.22-.44h8.16z"/><path d="M18 9a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1z"/>';
export var LaptopOutlineSVG = function LaptopOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
LaptopOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LaptopOutlineSVG);